import React, { Component, createRef } from 'react';
import classnames from 'classnames';
import {Col, Row} from 'react-bootstrap';
import _ from 'underscore';

class SearchSidebarView extends Component {

    inputRef = createRef();

    componentDidMount() {
        this.debouncedHandleChange = _.debounce((event) => {
            this.props.handleChange({q: event.target.value});
        }, 500);
    }

    handleChange = (event) => {
        // React 17+ removed event pooling, so the synthetic event survives into
        // the debounced callback without persist() (which is now a no-op).
        this.debouncedHandleChange(event);
    }

    blurInput() {
        this.inputRef.current.blur();
    }

    render() {
        return (
            <Row>
                <Col xs={12} className="form-group">
                    <span className="community-sidebar-input-title">{this.props.name}</span>
                </Col>
                <Col xs={12} className="form-group">
                    <input ref={this.inputRef}
                        type="search"
                        className="form-control"
                        onChange={this.handleChange}
                        placeholder={this.props.placeHolder}
                        defaultValue={this.props.defaultValue}/>
                </Col>
            </Row>
        );
    }
}

export default SearchSidebarView;


